module.exports = __webpack_public_path__ + "img/building.d570c07f.svg";